import store from '../store'

export default async (to, from, next) => {
  const user = await store.dispatch('userIsAdmin')
  let path

  // Check if user has access
  // User's profile being viewed has Designs that belong under a company (dealer or builder)
  // Viewer must be system admin or an Employee under the company that also has company admin access

  if (!user || !user.isAdmin) path = '/503'

  next(path)
}



// WEBPACK FOOTER //
// ./src/router/auth-client-info.js